let Nav = function () {

    $('.navbar-toggler').on('click keypress', function () {
        $('.nav-menu__container').addClass('nav-open');
        const scrollY = window.scrollY + "px";
        document.body.style.top = `-${scrollY}`;
        setTimeout(() => {
            document.body.style.position = 'fixed';
        }, 600);
    });

    $('#nav-close, #nav-close-desktop').on('click', function () {
        $('.nav-menu__container').removeClass('nav-open');
        const scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        document.documentElement.style = "scroll-behavior: auto";
        window.scrollTo(0, parseInt(scrollY || '0') * -1);
        window.addEventListener('scroll', () => {
            document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
        });
    });

    $('.cart__continue-shopping').on('click', function () {
        $('cart-drawer').removeClass('open');
    });

    if ($('[mx-alert-modal]').length > 0) {
        $('body, .cart-drawer, .artist-modal, .full-specs, .gallery-modal, .swatch-modal, .video-modal').addClass('alert-active');
    }

    $('#alert-close').on('click keypress', function () {
        $('body, .main-header, .cart-drawer, .artist-modal, .full-specs, .gallery-modal, .swatch-modal, .video-modal').removeClass('alert-active'); 
        $('[mx-alert-modal]').fadeOut();
    });

}

export default Nav;